import type { Order, OrderStatus } from "./types";
import { ProgressBar } from "./progress-bar";
import { formatIndianCurrency } from "@/app/utils/helper";
import { StatusBadge } from "./status-badge";
import { ORDER_STATUS } from "@/app/enums/orders";
interface OrderDetailsProps {
    details: NonNullable<Order["details"]>;
    basketTxns?: Order["basketTxns"];
}

export function OrderDetails({ details, basketTxns }: OrderDetailsProps) {
    return (
        <div className="space-y-4">
            <div className="grid grid-cols-[1fr_1fr_1fr_auto] gap-4 text-sm text-gray-500">
                <div>
                    <span className="text-sm font-medium text-neutral-300">Type:&nbsp;</span>
                    <span className="font-medium text-gray-900">{details.type}</span>
                </div>

                <div>
                    <span className="text-sm font-medium text-neutral-300">
                        Price per share:&nbsp;
                    </span>
                    <span className="font-medium text-gray-900">₹{details.pricePerShare}</span>
                </div>

                <div className="-mr-2">
                    <span className="text-sm font-medium text-neutral-300">Units:&nbsp;</span>
                    <span className="font-medium text-gray-900">{details.units}</span>
                </div>

                <div className="-ml-10">
                    <span className="text-nowrap text-sm font-medium text-neutral-300">
                        Transaction Id:&nbsp;
                    </span>
                    <span
                        className="truncate font-medium text-gray-900"
                        title={details.transactionId}
                    >
                        {details.transactionId}
                    </span>
                </div>
            </div>
            <ProgressBar stages={details.stages} />

            {basketTxns &&
                basketTxns?.map((txn, index) => {
                    return (
                        <div key={index} className="flex w-full items-center gap-3">
                            <p
                                title={txn?.displayName}
                                className="min-w-[237px] max-w-[237px] truncate py-s9 font-semibold"
                            >
                                {txn?.displayName}
                            </p>
                            <p className="min-w-[151px] max-w-[151px] py-s9 text-center">
                                Purchase
                            </p>
                            <p></p>
                            <StatusBadge
                                status={ORDER_STATUS[txn?.status] as unknown as OrderStatus}
                                isExpanded={false}
                                showChevron={false}
                            />
                            <p className="min-w-[125px] max-w-[125px] px-s11 py-s9">{formatIndianCurrency(txn?.amount ?? 0)}</p>
                            <p className="min-w-[70px] max-w-[70px] px-s11 py-s9">{txn?.units}</p>
                        </div>
                    );
                })}
        </div>
    );
}
